export default "__VITE_ASSET__D$dqkvTx__"